export const cashflowTranslations: Record<string, any> = {
  "pt": {
    title: "Fluxo de Caixa",
    subtitle: "Acompanha o teu fluxo de caixa e projeções futuras",
    loading_overview: "A carregar fluxo de caixa...",
    load_error: "Não foi possível carregar o fluxo de caixa.",
    no_data_label: "Sem dados para o período selecionado.",
    real_data_label: "Dados reais",
    monthly_cashflow: "Fluxo de caixa mensal",
    income_breakdown: "Receitas por categoria",
    expense_breakdown: "Despesas por categoria",
    no_categories: "Sem categorias",
    uncategorized: "Sem categoria",
    uncategorized_badge: "Por classificar",
    uncategorized_hint: "Classificar melhora previsões e alertas",
    budget_difference: "Diferença orçamental",
    liquidity_risk_title: "Risco de liquidez",
    liquidity_risk_description: "Saldo projetado negativo neste mês (despesas superiores às receitas).",
    liquidity_drop_title: "Queda de liquidez",
    liquidity_drop_description: "Saldo projetado caiu de forma acentuada face ao mês anterior.",
    liquidity_delta_label: "Variação vs mês anterior",
    liquidity_drop_percent_label: "Queda",
    all_accounts: "Todas as contas",
    all_accounts_short: "Todas",
    n_selected: "{{count}} selecionadas",
    search_accounts: "Pesquisar contas...",
    viewing_actual: "A ver: Real",
    viewing_projected: "A ver: Projetado",
    viewing_baseline_projection: "Projeção baseline",
    viewing_baseline_projection_short: "Baseline",
    viewing_budget_projection: "Projeção orçamental",
    viewing_budget_projection_short: "Orçamento",
    based_on_budgets: "Baseado nos orçamentos atuais",
    assumes_recurring_continue: "Assume que receitas e despesas recorrentes continuam",
    based_on_budget_assumptions: "Baseado nas suas premissas orçamentais",
    tooltip_baseline_title: "Projeção baseline",
    tooltip_baseline_description: "Os meses futuros assumem que as suas receitas e despesas recorrentes atuais continuam inalteradas.",
    tooltip_budget_title: "Projeção orçamental",
    tooltip_budget_description: "Os meses futuros refletem os seus ajustes orçamentais.",
    tooltip_pulse_title: "Saldo Projetado do Mês",
    tooltip_pulse_description: "Mostra como o seu saldo de caixa evolui ao longo do tempo. Os meses passados refletem saldos reais. Os meses futuros são projetados.",
    empty_state_title: "Ainda não existem dados de fluxo de caixa",
    empty_state_description: "Liga uma conta bancária para começar a acompanhar o seu fluxo de caixa em tempo real e projeções futuras.",
    empty_state_button: "Conectar banco",
    accounts: "Contas",
    bank_accounts: "Contas Bancárias",
    actual: "Real",
    with_budget: "Com Orçamento",
    compare_with_budget: "Comparar fluxo de caixa com orçamento",
    budget_disabled_previous_year: "As projeções com orçamento só estão disponíveis para o ano atual.",
    group_by: "Agrupar por",
    group_by_clients: "Clientes",
    group_by_projects: "Projetos",
    group_by_vendors: "Fornecedores",
    group_by_none: "Nenhum",
    previous_year: "Ano anterior",
    next_year: "Ano seguinte",
    unassigned: "Sem associação",
    total_income_ytd: "Receita Total (Acum. Ano)",
    total_expenses_ytd: "Despesas Totais (Acum. Ano)",
    net_cashflow_ytd: "Fluxo de Caixa Líquido (Acum. Ano)",
    net_cashflow_month: "Fluxo de Caixa Líquido (Mês)",
    end_of_year_projection: "Projeção Fim de Ano",
    jan_to: "Jan - ",
    full_year: "Ano Completo 2026",
    assuming_budgets_unchanged: "Assumindo que os orçamentos atuais permanecem inalterados",
    begin_cashflow: "Saldo Inicial do Mês",
    balance_start_month: "Saldo disponível no início do mês",
    opening_balance_zero_title: "Saldo inicial indisponível",
    opening_balance_zero_description: "Não existe histórico de saldo disponível para este período, por isso o saldo inicial é apresentado como 0.",
    pulse_cashflow: "Saldo Projetado do Mês",
    projected_operational_balance: "Saldo operacional projetado",
    income: "RECEITAS",
    expenses: "DESPESAS",
    net_cashflow: "Fluxo de Caixa Líquido",
    pulse_cash: "PULSE Cash on Hand",
    end_cashflow: "Fim Fluxo de Caixa",
    month_total: "Total do Mês",
    months: {
    january: "Janeiro",
    february: "Fevereiro",
    march: "Março",
    april: "Abril",
    may: "Maio",
    june: "Junho",
    july: "Julho",
    august: "Agosto",
    september: "Setembro",
    october: "Outubro",
    november: "Novembro",
    december: "Dezembro"
    },
    months_short: {
    jan: "Jan",
    feb: "Fev",
    mar: "Mar",
    apr: "Abr",
    may: "Mai",
    jun: "Jun",
    jul: "Jul",
    aug: "Ago",
    sep: "Set",
    oct: "Out",
    nov: "Nov",
    dec: "Dez"
    }
  },
  "en": {
    title: "Cash Flow",
    subtitle: "Track your cash flow and future projections",
    loading_overview: "Loading cash flow...",
    load_error: "Failed to load cash flow.",
    no_data_label: "No data for the selected period.",
    real_data_label: "Real data",
    monthly_cashflow: "Monthly cash flow",
    income_breakdown: "Income by category",
    expense_breakdown: "Expenses by category",
    no_categories: "No categories",
    uncategorized: "Uncategorized",
    uncategorized_badge: "To classify",
    uncategorized_hint: "Classifying improves forecasts and alerts",
    budget_difference: "Budget difference",
    liquidity_risk_title: "Liquidity risk",
    liquidity_risk_description: "Projected balance is negative this month (expenses exceed income).",
    liquidity_drop_title: "Liquidity decline",
    liquidity_drop_description: "Projected balance dropped significantly compared to the previous month.",
    liquidity_delta_label: "Change vs previous month",
    liquidity_drop_percent_label: "Drop",
    all_accounts: "All accounts",
    all_accounts_short: "All",
    n_selected: "{{count}} selected",
    search_accounts: "Search accounts...",
    viewing_actual: "Viewing: Actual",
    viewing_projected: "Viewing: Projected",
    viewing_baseline_projection: "Baseline projection",
    viewing_baseline_projection_short: "Baseline",
    viewing_budget_projection: "Budget projection",
    viewing_budget_projection_short: "Budget",
    based_on_budgets: "Based on current budgets",
    assumes_recurring_continue: "Assumes current recurring income and expenses continue",
    based_on_budget_assumptions: "Based on your current budget assumptions",
    tooltip_baseline_title: "Baseline projection",
    tooltip_baseline_description: "Future months assume your current recurring income and expenses continue unchanged.",
    tooltip_budget_title: "Budget projection",
    tooltip_budget_description: "Future months reflect your budgeted adjustments.",
    tooltip_pulse_title: "Projected Balance (Month)",
    tooltip_pulse_description: "Shows how your cash balance evolves over time. Past months reflect actual balances. Future months are projected.",
    empty_state_title: "No cash flow data yet",
    empty_state_description: "Connect your bank account to start tracking your cash flow in real-time and future projections.",
    empty_state_button: "Connect bank account",
    accounts: "Accounts",
    bank_accounts: "Bank Accounts",
    actual: "Actual",
    with_budget: "With Budget",
    compare_with_budget: "Compare cash flow with budget",
    budget_disabled_previous_year: "Budget projections are only available for the current year.",
    group_by: "Group by",
    group_by_clients: "Clients",
    group_by_projects: "Projects",
    group_by_vendors: "Vendors",
    group_by_none: "None",
    previous_year: "Previous year",
    next_year: "Next year",
    unassigned: "Unassigned",
    total_income_ytd: "Total Income YTD",
    total_expenses_ytd: "Total Expenses YTD",
    net_cashflow_ytd: "Net Cash Flow YTD",
    net_cashflow_month: "Net Cash Flow (Month)",
    end_of_year_projection: "End of Year Projection",
    jan_to: "Jan - ",
    full_year: "Full year 2026",
    assuming_budgets_unchanged: "Assuming current budgets remain unchanged",
    begin_cashflow: "Opening Balance (Month)",
    balance_start_month: "Available bank balance at the start of the month",
    opening_balance_zero_title: "Opening balance unavailable",
    opening_balance_zero_description: "No available bank balance history for this period, so the opening balance is shown as 0.",
    pulse_cashflow: "Projected Balance (Month)",
    projected_operational_balance: "Projected operational balance",
    income: "INCOME",
    expenses: "EXPENSES",
    net_cashflow: "Net Cash Flow",
    pulse_cash: "PULSE Cash on Hand",
    end_cashflow: "End Cash Flow",
    month_total: "Month Total",
    months: {
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December"
    },
    months_short: {
    jan: "Jan",
    feb: "Feb",
    mar: "Mar",
    apr: "Apr",
    may: "May",
    jun: "Jun",
    jul: "Jul",
    aug: "Aug",
    sep: "Sep",
    oct: "Oct",
    nov: "Nov",
    dec: "Dec"
    }
  },
  "es": {
    title: "Flujo de Caja",
    subtitle: "Controla tu flujo de caja y las proyecciones futuras",
    loading_overview: "Cargando flujo de caja...",
    load_error: "No se pudo cargar el flujo de caja.",
    no_data_label: "Sin datos para el período seleccionado.",
    real_data_label: "Datos reales",
    monthly_cashflow: "Flujo de caja mensual",
    income_breakdown: "Ingresos por categoría",
    expense_breakdown: "Gastos por categoría",
    no_categories: "Sin categorías",
    uncategorized: "Sin categoría",
    uncategorized_badge: "Por clasificar",
    uncategorized_hint: "Clasificar mejora previsiones y alertas",
    budget_difference: "Diferencia presupuestaria",
    liquidity_risk_title: "Riesgo de liquidez",
    liquidity_risk_description: "Saldo proyectado negativo este mes (gastos superiores a ingresos).",
    liquidity_drop_title: "Caída de liquidez",
    liquidity_drop_description: "El saldo proyectado cayó de forma significativa frente al mes anterior.",
    liquidity_delta_label: "Variación vs mes anterior",
    liquidity_drop_percent_label: "Caída",
    all_accounts: "Todas las cuentas",
    all_accounts_short: "Todas",
    n_selected: "{{count}} seleccionadas",
    search_accounts: "Buscar cuentas...",
    viewing_actual: "Viendo: Real",
    viewing_projected: "Viendo: Proyectado",
    viewing_baseline_projection: "Proyección baseline",
    viewing_baseline_projection_short: "Baseline",
    viewing_budget_projection: "Proyección presupuestaria",
    viewing_budget_projection_short: "Presupuesto",
    based_on_budgets: "Basado en presupuestos actuales",
    assumes_recurring_continue: "Asume que ingresos y gastos recurrentes continúan",
    based_on_budget_assumptions: "Basado en sus premisas presupuestarias actuales",
    tooltip_baseline_title: "Proyección baseline",
    tooltip_baseline_description: "Los meses futuros asumen que sus ingresos y gastos recurrentes actuales continúan sin cambios.",
    tooltip_budget_title: "Proyección presupuestaria",
    tooltip_budget_description: "Los meses futuros reflejan sus ajustes presupuestarios.",
    tooltip_pulse_title: "Saldo Proyectado del Mes",
    tooltip_pulse_description: "Muestra cómo evoluciona su saldo de efectivo con el tiempo. Los meses pasados reflejan saldos reales. Los meses futuros son proyectados.",
    empty_state_title: "Aún no hay datos de flujo de caja",
    empty_state_description: "Conecta tu cuenta bancaria para empezar a rastrear tu flujo de caja en tiempo real y proyecciones futuras.",
    empty_state_button: "Conectar banco",
    accounts: "Cuentas",
    bank_accounts: "Cuentas Bancarias",
    actual: "Real",
    with_budget: "Con Presupuesto",
    compare_with_budget: "Comparar flujo de caja con presupuesto",
    budget_disabled_previous_year: "Las proyecciones con presupuesto solo están disponibles para el año actual.",
    group_by: "Agrupar por",
    group_by_clients: "Clientes",
    group_by_projects: "Proyectos",
    group_by_vendors: "Proveedores",
    group_by_none: "Ninguno",
    previous_year: "Año anterior",
    next_year: "Siguiente año",
    unassigned: "Sin asignar",
    total_income_ytd: "Ingresos Totales (Acum. Año)",
    total_expenses_ytd: "Gastos Totales (Acum. Año)",
    net_cashflow_ytd: "Flujo de Caja Neto (Acum. Año)",
    net_cashflow_month: "Flujo de Caja Neto (Mes)",
    end_of_year_projection: "Proyección Fin de Año",
    jan_to: "Ene - ",
    full_year: "Año Completo 2026",
    assuming_budgets_unchanged: "Asumiendo que los presupuestos actuales permanecen sin cambios",
    begin_cashflow: "Saldo Inicial del Mes",
    balance_start_month: "Saldo al inicio del mes",
    pulse_cashflow: "Saldo Proyectado del Mes",
    projected_operational_balance: "Saldo operacional proyectado",
    income: "INGRESOS",
    expenses: "GASTOS",
    net_cashflow: "Flujo de Caja Neto",
    pulse_cash: "PULSE Cash on Hand",
    end_cashflow: "Fin Flujo de Caja",
    month_total: "Total del Mes",
    months: {
    january: "Enero",
    february: "Febrero",
    march: "Marzo",
    april: "Abril",
    may: "Mayo",
    june: "Junio",
    july: "Julio",
    august: "Agosto",
    september: "Septiembre",
    october: "Octubre",
    november: "Noviembre",
    december: "Diciembre"
    },
    months_short: {
    jan: "Ene",
    feb: "Feb",
    mar: "Mar",
    apr: "Abr",
    may: "May",
    jun: "Jun",
    jul: "Jul",
    aug: "Ago",
    sep: "Sep",
    oct: "Oct",
    nov: "Nov",
    dec: "Dic"
    }
  },
  "et": {
    title: "Rahavoog",
    subtitle: "Jälgi oma rahavoogu ja tuleviku prognoose",
    loading_overview: "Rahavoo laadimine...",
    load_error: "Rahavoogu ei õnnestunud laadida.",
    no_data_label: "Valitud perioodil puuduvad andmed.",
    real_data_label: "Tegelikud andmed",
    monthly_cashflow: "Kuine rahavoog",
    income_breakdown: "Tulud kategooriate kaupa",
    expense_breakdown: "Kulud kategooriate kaupa",
    no_categories: "Kategooriaid pole",
    uncategorized: "Määramata",
    uncategorized_badge: "Vajab liigitust",
    uncategorized_hint: "Liigitamine parandab prognoose ja hoiatusi",
    budget_difference: "Eelarve erinevus",
    liquidity_risk_title: "Likviidsusrisk",
    liquidity_risk_description: "Selle kuu prognoositud saldo on negatiivne (kulud ületavad tulusid).",
    liquidity_drop_title: "Likviidsuse langus",
    liquidity_drop_description: "Prognoositud saldo langes oluliselt võrreldes eelmise kuuga.",
    liquidity_delta_label: "Muutus vs eelmine kuu",
    liquidity_drop_percent_label: "Langus",
    all_accounts: "Kõik kontod",
    all_accounts_short: "Kõik",
    n_selected: "{{count}} valitud",
    search_accounts: "Otsi kontosid...",
    viewing_actual: "Vaatamine: Tegelik",
    viewing_projected: "Vaatamine: Prognoositav",
    viewing_baseline_projection: "Baseline prognoos",
    viewing_baseline_projection_short: "Baseline",
    viewing_budget_projection: "Eelarve prognoos",
    viewing_budget_projection_short: "Eelarve",
    based_on_budgets: "Põhineb praegustel eelarvetel",
    assumes_recurring_continue: "Eeldab, et praegused korduvad tulud ja kulud jätkuvad",
    based_on_budget_assumptions: "Põhineb teie praegustel eelarve eeldustel",
    tooltip_baseline_title: "Baseline prognoos",
    tooltip_baseline_description: "Tulevaste kuude puhul eeldatakse, et teie praegused korduvad tulud ja kulud jätkuvad muutumatult.",
    tooltip_budget_title: "Eelarve prognoos",
    tooltip_budget_description: "Tulevased kuud kajastavad teie eelarve korrigeerimisi.",
    tooltip_pulse_title: "Kuu prognoositud saldo",
    tooltip_pulse_description: "Näitab, kuidas teie raha saldo aja jooksul areneb. Möödunud kuud kajastavad tegelikke saldosid. Tulevased kuud on prognoositud.",
    empty_state_title: "Rahavoo andmeid pole veel",
    empty_state_description: "Ühendage oma pangakonto, et alustada oma rahavoo jälgimist reaalajas ja tulevaste projektsioonidega.",
    empty_state_button: "Ühenda pangakonto",
    accounts: "Kontod",
    bank_accounts: "Pangakontod",
    actual: "Tegelik",
    with_budget: "Eelarvega",
    compare_with_budget: "Võrdle rahavoogu eelarvega",
    budget_disabled_previous_year: "Eelarveprojektsioonid on saadaval ainult käesolevaks aastaks.",
    group_by: "Rühmitus",
    group_by_clients: "Kliendid",
    group_by_projects: "Projektid",
    group_by_vendors: "Tarnijad",
    group_by_none: "Puudub",
    previous_year: "Eelmine aasta",
    next_year: "Järgmine aasta",
    unassigned: "Määramata",
    total_income_ytd: "Kogu Sissetulek (Aasta)",
    total_expenses_ytd: "Kogu Kulud (Aasta)",
    net_cashflow_ytd: "Netorahavoog (Aasta)",
    net_cashflow_month: "Netorahavoog (Kuu)",
    end_of_year_projection: "Aasta Lõpu Prognoos",
    jan_to: "Jaan - ",
    full_year: "Täisaasta",
    income: "Sissetulekud",
    expenses: "Kulud",
    net_cashflow: "Netorahavoog",
    begin_cashflow: "Kuu algsaldo",
    balance_start_month: "Saldo kuu alguses",
    pulse_cashflow: "Kuu prognoositud saldo",
    projected_operational_balance: "Prognoositav tegevussaldo",
    pulse_cash: "PULSE Cash on Hand",
    end_cashflow: "Lõplik Rahavoog",
    month_total: "Kuu Kogusumma",
    months: {
    january: "Jaanuar",
    february: "Veebruar",
    march: "Märts",
    april: "Aprill",
    may: "Mai",
    june: "Juuni",
    july: "Juuli",
    august: "August",
    september: "September",
    october: "Oktoober",
    november: "November",
    december: "Detsember"
    },
    months_short: {
    jan: "Jaan",
    feb: "Veebr",
    mar: "Märts",
    apr: "Apr",
    may: "Mai",
    jun: "Juuni",
    jul: "Juuli",
    aug: "Aug",
    sep: "Sept",
    oct: "Okt",
    nov: "Nov",
    dec: "Dets"
    }
  },
  "de": {
    title: "Cashflow",
    subtitle: "Beobachte deinen Cashflow und zukünftige Prognosen",
    loading_overview: "Cashflow wird geladen...",
    load_error: "Cashflow konnte nicht geladen werden.",
    no_data_label: "Keine Daten für den ausgewählten Zeitraum.",
    real_data_label: "Reale Daten",
    monthly_cashflow: "Monatlicher Cashflow",
    income_breakdown: "Einnahmen nach Kategorie",
    expense_breakdown: "Ausgaben nach Kategorie",
    no_categories: "Keine Kategorien",
    uncategorized: "Nicht kategorisiert",
    uncategorized_badge: "Zu kategorisieren",
    uncategorized_hint: "Kategorisieren verbessert Prognosen und Warnungen",
    budget_difference: "Budgetabweichung",
    liquidity_risk_title: "Liquiditätsrisiko",
    liquidity_risk_description: "Projizierter Saldo ist in diesem Monat negativ (Ausgaben übersteigen Einnahmen).",
    liquidity_drop_title: "Liquiditätsrückgang",
    liquidity_drop_description: "Projizierter Saldo ist im Vergleich zum Vormonat deutlich gesunken.",
    liquidity_delta_label: "Veränderung vs Vormonat",
    liquidity_drop_percent_label: "Rückgang",
    all_accounts: "Alle Konten",
    all_accounts_short: "Alle",
    n_selected: "{{count}} ausgewählt",
    search_accounts: "Konten suchen...",
    viewing_actual: "Ansicht: Ist",
    viewing_projected: "Ansicht: Prognostiziert",
    viewing_baseline_projection: "Baseline-Prognose",
    viewing_baseline_projection_short: "Baseline",
    viewing_budget_projection: "Budget-Prognose",
    viewing_budget_projection_short: "Budget",
    based_on_budgets: "Basierend auf aktuellen Budgets",
    assumes_recurring_continue: "Geht davon aus, dass aktuelle wiederkehrende Einnahmen und Ausgaben fortgesetzt werden",
    based_on_budget_assumptions: "Basierend auf Ihren aktuellen Budget-Annahmen",
    tooltip_baseline_title: "Baseline-Prognose",
    tooltip_baseline_description: "Zukünftige Monate gehen davon aus, dass Ihre aktuellen wiederkehrenden Einnahmen und Ausgaben unverändert fortgesetzt werden.",
    tooltip_budget_title: "Budget-Prognose",
    tooltip_budget_description: "Zukünftige Monate spiegeln Ihre Budget-Anpassungen wider.",
    tooltip_pulse_title: "Projizierter Monatssaldo",
    tooltip_pulse_description: "Zeigt, wie sich Ihr Kassenbestand im Laufe der Zeit entwickelt. Vergangene Monate spiegeln tatsächliche Salden wider. Zukünftige Monate sind prognostiziert.",
    empty_state_title: "Noch keine Cashflow-Daten",
    empty_state_description: "Verbinden Sie Ihr Bankkonto, um Ihren Cashflow in Echtzeit und zukünftige Prognosen zu verfolgen.",
    empty_state_button: "Bankkonto verbinden",
    accounts: "Konten",
    bank_accounts: "Bankkonten",
    actual: "Ist",
    with_budget: "Mit Budget",
    compare_with_budget: "Cashflow mit Budget vergleichen",
    budget_disabled_previous_year: "Budget-Prognosen sind nur für das aktuelle Jahr verfügbar.",
    group_by: "Gruppieren nach",
    group_by_clients: "Kunden",
    group_by_projects: "Projekte",
    group_by_vendors: "Lieferanten",
    group_by_none: "Keine",
    previous_year: "Vorheriges Jahr",
    next_year: "Nächstes Jahr",
    unassigned: "Nicht zugeordnet",
    total_income_ytd: "Gesamteinkommen (Jahr)",
    total_expenses_ytd: "Gesamtausgaben (Jahr)",
    net_cashflow_ytd: "Netto-Cashflow (Jahr)",
    net_cashflow_month: "Netto-Cashflow (Monat)",
    end_of_year_projection: "Jahresendeprognose",
    jan_to: "Jan - ",
    full_year: "Gesamtjahr 2026",
    assuming_budgets_unchanged: "Unter der Annahme unveränderter Budgets",
    begin_cashflow: "Anfangssaldo des Monats",
    balance_start_month: "Saldo zu Monatsbeginn",
    pulse_cashflow: "Projizierter Monatssaldo",
    projected_operational_balance: "Prognostiziertes Betriebssaldo",
    income: "EINNAHMEN",
    expenses: "AUSGABEN",
    net_cashflow: "Netto-Cashflow",
    pulse_cash: "PULSE Cash on Hand",
    end_cashflow: "Cashflow-Ende",
    month_total: "Monatssumme",
    months: {
    january: "Januar",
    february: "Februar",
    march: "März",
    april: "April",
    may: "Mai",
    june: "Juni",
    july: "Juli",
    august: "August",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "Dezember"
    },
    months_short: {
    jan: "Jan",
    feb: "Feb",
    mar: "Mär",
    apr: "Apr",
    may: "Mai",
    jun: "Jun",
    jul: "Jul",
    aug: "Aug",
    sep: "Sep",
    oct: "Okt",
    nov: "Nov",
    dec: "Dez"
    }
  },
  "fr": {
    title: "Flux de Trésorerie",
    subtitle: "Suivez votre trésorerie et les projections futures",
    loading_overview: "Chargement du flux de trésorerie...",
    load_error: "Impossible de charger le flux de trésorerie.",
    no_data_label: "Aucune donnée pour la période sélectionnée.",
    real_data_label: "Données réelles",
    monthly_cashflow: "Flux de trésorerie mensuel",
    income_breakdown: "Revenus par catégorie",
    expense_breakdown: "Dépenses par catégorie",
    no_categories: "Aucune catégorie",
    uncategorized: "Non catégorisé",
    uncategorized_badge: "À classer",
    uncategorized_hint: "Classer améliore les prévisions et alertes",
    budget_difference: "Écart budgétaire",
    liquidity_risk_title: "Risque de liquidité",
    liquidity_risk_description: "Solde projeté négatif ce mois-ci (dépenses supérieures aux revenus).",
    liquidity_drop_title: "Baisse de liquidité",
    liquidity_drop_description: "Le solde projeté a fortement diminué par rapport au mois précédent.",
    liquidity_delta_label: "Variation vs mois précédent",
    liquidity_drop_percent_label: "Baisse",
    all_accounts: "Tous les comptes",
    all_accounts_short: "Tous",
    n_selected: "{{count}} sélectionnés",
    search_accounts: "Rechercher des comptes...",
    viewing_actual: "Affichage : Réel",
    viewing_projected: "Affichage : Projeté",
    viewing_baseline_projection: "Projection baseline",
    viewing_baseline_projection_short: "Baseline",
    viewing_budget_projection: "Projection budgétaire",
    viewing_budget_projection_short: "Budget",
    based_on_budgets: "Basé sur les budgets actuels",
    assumes_recurring_continue: "Suppose que les revenus et dépenses récurrents actuels se poursuivent",
    based_on_budget_assumptions: "Basé sur vos hypothèses budgétaires actuelles",
    tooltip_baseline_title: "Projection baseline",
    tooltip_baseline_description: "Les mois futurs supposent que vos revenus et dépenses récurrents actuels se poursuivent sans changement.",
    tooltip_budget_title: "Projection budgétaire",
    tooltip_budget_description: "Les mois futurs reflètent vos ajustements budgétaires.",
    tooltip_pulse_title: "Solde projeté du mois",
    tooltip_pulse_description: "Montre comment votre solde de trésorerie évolue au fil du temps. Les mois passés reflètent les soldes réels. Les mois futurs sont projetés.",
    empty_state_title: "Pas encore de données de flux de trésorerie",
    empty_state_description: "Connectez votre compte bancaire pour commencer à suivre votre flux de trésorerie en temps réel et les projections futures.",
    empty_state_button: "Connecter un compte bancaire",
    accounts: "Comptes",
    bank_accounts: "Comptes Bancaires",
    actual: "Réel",
    with_budget: "Avec Budget",
    compare_with_budget: "Comparer le flux de trésorerie avec le budget",
    budget_disabled_previous_year: "Les projections budgétaires ne sont disponibles que pour l'année en cours.",
    group_by: "Grouper par",
    group_by_clients: "Clients",
    group_by_projects: "Projets",
    group_by_vendors: "Fournisseurs",
    group_by_none: "Aucun",
    previous_year: "Année précédente",
    next_year: "Année suivante",
    unassigned: "Non attribué",
    total_income_ytd: "Revenus Totaux (Année)",
    total_expenses_ytd: "Dépenses Totales (Année)",
    net_cashflow_ytd: "Flux de Trésorerie Net (Année)",
    net_cashflow_month: "Flux de Trésorerie Net (Mois)",
    end_of_year_projection: "Projection de Fin d'Année",
    jan_to: "Jan - ",
    full_year: "Année Complète 2026",
    assuming_budgets_unchanged: "En supposant que les budgets restent inchangés",
    begin_cashflow: "Solde initial du mois",
    balance_start_month: "Solde en début de mois",
    pulse_cashflow: "Solde projeté du mois",
    projected_operational_balance: "Solde opérationnel projeté",
    income: "REVENUS",
    expenses: "DÉPENSES",
    net_cashflow: "Flux de Trésorerie Net",
    pulse_cash: "PULSE Cash on Hand",
    end_cashflow: "Fin du Flux de Trésorerie",
    month_total: "Total Mensuel",
    months: {
    january: "Janvier",
    february: "Février",
    march: "Mars",
    april: "Avril",
    may: "Mai",
    june: "Juin",
    july: "Juillet",
    august: "Août",
    september: "Septembre",
    october: "Octobre",
    november: "Novembre",
    december: "Décembre"
    },
    months_short: {
    jan: "Jan",
    feb: "Fév",
    mar: "Mars",
    apr: "Avr",
    may: "Mai",
    jun: "Juin",
    jul: "Juil",
    aug: "Août",
    sep: "Sep",
    oct: "Oct",
    nov: "Nov",
    dec: "Déc"
    }
  },
  "it": {
    title: "Flusso di Cassa",
    subtitle: "Monitora il tuo flusso di cassa e le proiezioni future",
    loading_overview: "Caricamento flusso di cassa...",
    load_error: "Impossibile caricare il flusso di cassa.",
    no_data_label: "Nessun dato per il periodo selezionato.",
    real_data_label: "Dati reali",
    monthly_cashflow: "Flusso di cassa mensile",
    income_breakdown: "Entrate per categoria",
    expense_breakdown: "Spese per categoria",
    no_categories: "Nessuna categoria",
    uncategorized: "Senza categoria",
    uncategorized_badge: "Da classificare",
    uncategorized_hint: "Classificare migliora previsioni e avvisi",
    budget_difference: "Differenza di budget",
    liquidity_risk_title: "Rischio di liquidità",
    liquidity_risk_description: "Saldo proiettato negativo questo mese (spese superiori alle entrate).",
    liquidity_drop_title: "Calo di liquidità",
    liquidity_drop_description: "Il saldo proiettato è diminuito in modo significativo rispetto al mese precedente.",
    liquidity_delta_label: "Variazione vs mese precedente",
    liquidity_drop_percent_label: "Calo",
    all_accounts: "Tutti i conti",
    all_accounts_short: "Tutti",
    n_selected: "{{count}} selezionati",
    search_accounts: "Cerca conti...",
    viewing_actual: "Visualizzazione: Effettivo",
    viewing_projected: "Visualizzazione: Proiettato",
    viewing_baseline_projection: "Proiezione baseline",
    viewing_baseline_projection_short: "Baseline",
    viewing_budget_projection: "Proiezione budget",
    viewing_budget_projection_short: "Budget",
    based_on_budgets: "Basato sui budget attuali",
    assumes_recurring_continue: "Presuppone che entrate e spese ricorrenti attuali continuino",
    based_on_budget_assumptions: "Basato sulle vostre attuali ipotesi di budget",
    tooltip_baseline_title: "Proiezione baseline",
    tooltip_baseline_description: "I mesi futuri presumono che le vostre entrate e spese ricorrenti attuali continuino invariate.",
    tooltip_budget_title: "Proiezione budget",
    tooltip_budget_description: "I mesi futuri riflettono i vostri aggiustamenti di budget.",
    tooltip_pulse_title: "Saldo proiettato del mese",
    tooltip_pulse_description: "Mostra come il vostro saldo di cassa evolve nel tempo. I mesi passati riflettono saldi effettivi. I mesi futuri sono proiettati.",
    empty_state_title: "Nessun dato di flusso di cassa ancora",
    empty_state_description: "Collega il tuo conto bancario per iniziare a monitorare il tuo flusso di cassa in tempo reale e le proiezioni future.",
    empty_state_button: "Collega conto bancario",
    accounts: "Conti",
    bank_accounts: "Conti Bancari",
    actual: "Effettivo",
    with_budget: "Con Budget",
    compare_with_budget: "Confronta il flusso di cassa con il budget",
    budget_disabled_previous_year: "Le proiezioni di budget sono disponibili solo per l'anno in corso.",
    group_by: "Raggruppa per",
    group_by_clients: "Clienti",
    group_by_projects: "Progetti",
    group_by_vendors: "Fornitori",
    group_by_none: "Nessuno",
    previous_year: "Anno precedente",
    next_year: "Anno successivo",
    unassigned: "Non assegnato",
    total_income_ytd: "Entrate Totali (Anno)",
    total_expenses_ytd: "Spese Totali (Anno)",
    net_cashflow_ytd: "Flusso di Cassa Netto (Anno)",
    net_cashflow_month: "Flusso di Cassa Netto (Mese)",
    end_of_year_projection: "Proiezione di Fine Anno",
    jan_to: "Gen - ",
    full_year: "Anno Completo 2026",
    assuming_budgets_unchanged: "Supponendo che i budget rimangano invariati",
    begin_cashflow: "Saldo iniziale del mese",
    balance_start_month: "Saldo a inizio mese",
    pulse_cashflow: "Saldo proiettato del mese",
    projected_operational_balance: "Saldo operativo previsto",
    income: "ENTRATE",
    expenses: "SPESE",
    net_cashflow: "Flusso di Cassa Netto",
    pulse_cash: "PULSE Cash on Hand",
    end_cashflow: "Fine Flusso di Cassa",
    month_total: "Totale Mensile",
    months: {
    january: "Gennaio",
    february: "Febbraio",
    march: "Marzo",
    april: "Aprile",
    may: "Maggio",
    june: "Giugno",
    july: "Luglio",
    august: "Agosto",
    september: "Settembre",
    october: "Ottobre",
    november: "Novembre",
    december: "Dicembre"
    },
    months_short: {
    jan: "Gen",
    feb: "Feb",
    mar: "Mar",
    apr: "Apr",
    may: "Mag",
    jun: "Giu",
    jul: "Lug",
    aug: "Ago",
    sep: "Set",
    oct: "Ott",
    nov: "Nov",
    dec: "Dic"
    }
  },
  "nl": {
    title: "Cashflow",
    subtitle: "Volg je cashflow en toekomstige prognoses",
    loading_overview: "Cashflow laden...",
    load_error: "Kan cashflow niet laden.",
    no_data_label: "Geen gegevens voor de geselecteerde periode.",
    real_data_label: "Echte data",
    monthly_cashflow: "Maandelijkse cashflow",
    income_breakdown: "Inkomsten per categorie",
    expense_breakdown: "Uitgaven per categorie",
    no_categories: "Geen categorieën",
    uncategorized: "Niet gecategoriseerd",
    uncategorized_badge: "Te classificeren",
    uncategorized_hint: "Classificeren verbetert prognoses en waarschuwingen",
    budget_difference: "Budgetverschil",
    liquidity_risk_title: "Liquiditeitsrisico",
    liquidity_risk_description: "Geprojecteerd saldo is deze maand negatief (uitgaven hoger dan inkomsten).",
    liquidity_drop_title: "Liquiditeitsdaling",
    liquidity_drop_description: "Geprojecteerd saldo is sterk gedaald t.o.v. vorige maand.",
    liquidity_delta_label: "Verschil vs vorige maand",
    liquidity_drop_percent_label: "Daling",
    all_accounts: "Alle rekeningen",
    all_accounts_short: "Alle",
    n_selected: "{{count}} geselecteerd",
    search_accounts: "Rekeningen zoeken...",
    viewing_actual: "Weergave: Actueel",
    viewing_projected: "Weergave: Geprojecteerd",
    viewing_baseline_projection: "Baseline projectie",
    viewing_baseline_projection_short: "Baseline",
    viewing_budget_projection: "Budget projectie",
    viewing_budget_projection_short: "Budget",
    based_on_budgets: "Gebaseerd op huidige budgetten",
    assumes_recurring_continue: "Gaat ervan uit dat huidige terugkerende inkomsten en uitgaven doorgaan",
    based_on_budget_assumptions: "Gebaseerd op uw huidige budgetveronderstellingen",
    tooltip_baseline_title: "Baseline projectie",
    tooltip_baseline_description: "Toekomstige maanden gaan ervan uit dat uw huidige terugkerende inkomsten en uitgaven ongewijzigd doorgaan.",
    tooltip_budget_title: "Budget projectie",
    tooltip_budget_description: "Toekomstige maanden weerspiegelen uw budgetaanpassingen.",
    tooltip_pulse_title: "Geprojecteerd saldo van de maand",
    tooltip_pulse_description: "Toont hoe uw kassaldo in de loop van de tijd evolueert. Afgelopen maanden weerspiegelen werkelijke saldi. Toekomstige maanden zijn geprojecteerd.",
    empty_state_title: "Nog geen cashflow-gegevens",
    empty_state_description: "Verbind uw bankrekening om uw cashflow in realtime te volgen en toekomstige projecties te bekijken.",
    empty_state_button: "Bankrekening verbinden",
    accounts: "Rekeningen",
    bank_accounts: "Bankrekeningen",
    actual: "Actueel",
    with_budget: "Met Budget",
    compare_with_budget: "Cashflow vergelijken met budget",
    budget_disabled_previous_year: "Budgetprognoses zijn alleen beschikbaar voor het huidige jaar.",
    group_by: "Groeperen op",
    group_by_clients: "Klanten",
    group_by_projects: "Projecten",
    group_by_vendors: "Leveranciers",
    group_by_none: "Geen",
    previous_year: "Vorig jaar",
    next_year: "Volgend jaar",
    unassigned: "Niet toegewezen",
    total_income_ytd: "Totale Inkomsten (Jaar)",
    total_expenses_ytd: "Totale Uitgaven (Jaar)",
    net_cashflow_ytd: "Netto Cashflow (Jaar)",
    net_cashflow_month: "Netto Cashflow (Maand)",
    end_of_year_projection: "Eindejaarsprojectie",
    jan_to: "Jan - ",
    full_year: "Volledig Jaar 2026",
    assuming_budgets_unchanged: "Ervan uitgaande dat budgetten ongewijzigd blijven",
    begin_cashflow: "Beginsaldo van de maand",
    balance_start_month: "Saldo aan het begin van de maand",
    pulse_cashflow: "Geprojecteerd saldo van de maand",
    projected_operational_balance: "Geprojecteerd operationeel saldo",
    income: "INKOMSTEN",
    expenses: "UITGAVEN",
    net_cashflow: "Netto Cashflow",
    pulse_cash: "PULSE Cash on Hand",
    end_cashflow: "Einde Cashflow",
    month_total: "Maandtotaal",
    months: {
    january: "Januari",
    february: "Februari",
    march: "Maart",
    april: "April",
    may: "Mei",
    june: "Juni",
    july: "Juli",
    august: "Augustus",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "December"
    },
    months_short: {
    jan: "Jan",
    feb: "Feb",
    mar: "Mrt",
    apr: "Apr",
    may: "Mei",
    jun: "Jun",
    jul: "Jul",
    aug: "Aug",
    sep: "Sep",
    oct: "Okt",
    nov: "Nov",
    dec: "Dec"
    }
  },
  "sv": {
    title: "Kassafl��de",
    subtitle: "Följ ditt kassaflöde och framtida prognoser",
    loading_overview: "Laddar kassaflöde...",
    load_error: "Kunde inte ladda kassaflöde.",
    no_data_label: "Inga data för den valda perioden.",
    real_data_label: "Faktiska data",
    monthly_cashflow: "Månatligt kassaflöde",
    income_breakdown: "Intäkter per kategori",
    expense_breakdown: "Utgifter per kategori",
    no_categories: "Inga kategorier",
    uncategorized: "Okategoriserad",
    uncategorized_badge: "Att klassificera",
    uncategorized_hint: "Klassificering förbättrar prognoser och varningar",
    budget_difference: "Budgetavvikelse",
    liquidity_risk_title: "Likviditetsrisk",
    liquidity_risk_description: "Projicerat saldo är negativt denna månad (utgifter överstiger intäkter).",
    liquidity_drop_title: "Likviditetsfall",
    liquidity_drop_description: "Projicerat saldo har minskat kraftigt jämfört med föregående månad.",
    liquidity_delta_label: "Förändring vs föregående månad",
    liquidity_drop_percent_label: "Nedgång",
    all_accounts: "Alla konton",
    all_accounts_short: "Alla",
    n_selected: "{{count}} valda",
    search_accounts: "Sök konton...",
    viewing_actual: "Visar: Faktiskt",
    viewing_projected: "Visar: Projicerat",
    viewing_baseline_projection: "Baseline-prognos",
    viewing_baseline_projection_short: "Baseline",
    viewing_budget_projection: "Budgetprognos",
    viewing_budget_projection_short: "Budget",
    based_on_budgets: "Baserat på nuvarande budgetar",
    assumes_recurring_continue: "Förutsätter att nuvarande återkommande intäkter och kostnader fortsätter",
    based_on_budget_assumptions: "Baserat på dina nuvarande budgetantaganden",
    tooltip_baseline_title: "Baseline-prognos",
    tooltip_baseline_description: "Framtida månader förutsätter att dina nuvarande återkommande intäkter och kostnader fortsätter oförändrade.",
    tooltip_budget_title: "Budgetprognos",
    tooltip_budget_description: "Framtida månader återspeglar dina budgetjusteringar.",
    tooltip_pulse_title: "Månadens projicerade saldo",
    tooltip_pulse_description: "Visar hur ditt kassasaldo utvecklas över tid. Tidigare månader återspeglar faktiska saldon. Framtida månader är projicerade.",
    empty_state_title: "Ingen kassaflödesdata ännu",
    empty_state_description: "Anslut ditt bankkonto för att börja spåra ditt kassaflöde i realtid och framtida prognoser.",
    empty_state_button: "Anslut bankkonto",
    accounts: "Konton",
    bank_accounts: "Bankkonton",
    actual: "Faktiskt",
    with_budget: "Med Budget",
    compare_with_budget: "Jämför kassaflöde med budget",
    budget_disabled_previous_year: "Budgetprognoser är endast tillgängliga för innevarande år.",
    group_by: "Gruppera efter",
    group_by_clients: "Kunder",
    group_by_projects: "Projekt",
    group_by_vendors: "Leverantörer",
    group_by_none: "Ingen",
    previous_year: "Föregående år",
    next_year: "Nästa år",
    unassigned: "Ej tilldelad",
    total_income_ytd: "Total Inkomst (År)",
    total_expenses_ytd: "Totala Utgifter (År)",
    net_cashflow_ytd: "Netto Kassaflöde (År)",
    net_cashflow_month: "Netto Kassaflöde (Månad)",
    end_of_year_projection: "Årsslutsprojektion",
    jan_to: "Jan - ",
    full_year: "Helår 2026",
    assuming_budgets_unchanged: "Förutsatt att budgetar förblir oförändrade",
    begin_cashflow: "Månadens ingångssaldo",
    balance_start_month: "Saldo i början av månaden",
    pulse_cashflow: "Månadens projicerade saldo",
    projected_operational_balance: "Prognostiserat verksamhetssaldo",
    income: "INKOMSTER",
    expenses: "UTGIFTER",
    net_cashflow: "Netto Kassaflöde",
    pulse_cash: "PULSE Cash on Hand",
    end_cashflow: "Slut Kassaflöde",
    month_total: "Månadstotal",
    months: {
    january: "Januari",
    february: "Februari",
    march: "Mars",
    april: "April",
    may: "Maj",
    june: "Juni",
    july: "Juli",
    august: "Augusti",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "December"
    },
    months_short: {
    jan: "Jan",
    feb: "Feb",
    mar: "Mar",
    apr: "Apr",
    may: "Maj",
    jun: "Jun",
    jul: "Jul",
    aug: "Aug",
    sep: "Sep",
    oct: "Okt",
    nov: "Nov",
    dec: "Dec"
    }
  },
  "da": {
    title: "Pengestrøm",
    subtitle: "Følg din pengestrøm og fremtidige prognoser",
    loading_overview: "Indlæser pengestrøm...",
    load_error: "Kunne ikke indlæse pengestrøm.",
    no_data_label: "Ingen data for den valgte periode.",
    real_data_label: "Reelle data",
    monthly_cashflow: "Månedlig pengestrøm",
    income_breakdown: "Indtægter efter kategori",
    expense_breakdown: "Udgifter efter kategori",
    no_categories: "Ingen kategorier",
    uncategorized: "Ikke kategoriseret",
    uncategorized_badge: "Til klassificering",
    uncategorized_hint: "Klassificering forbedrer prognoser og advarsler",
    budget_difference: "Budgetafvigelse",
    liquidity_risk_title: "Likviditetsrisiko",
    liquidity_risk_description: "Projiceret saldo er negativt denne måned (udgifter overstiger indtægter).",
    liquidity_drop_title: "Likviditetsfald",
    liquidity_drop_description: "Projiceret saldo er faldet markant i forhold til forrige måned.",
    liquidity_delta_label: "Ændring vs forrige måned",
    liquidity_drop_percent_label: "Fald",
    all_accounts: "Alle konti",
    all_accounts_short: "Alle",
    n_selected: "{{count}} valgte",
    search_accounts: "Søg konti...",
    viewing_actual: "Viser: Faktisk",
    viewing_projected: "Viser: Forventet",
    viewing_baseline_projection: "Baseline-prognose",
    viewing_baseline_projection_short: "Baseline",
    viewing_budget_projection: "Budgetprognose",
    viewing_budget_projection_short: "Budget",
    based_on_budgets: "Baseret på aktuelle budgetter",
    assumes_recurring_continue: "Antager at nuværende tilbagevendende indtægter og udgifter fortsætter",
    based_on_budget_assumptions: "Baseret på dine nuværende budgetantagelser",
    tooltip_baseline_title: "Baseline-prognose",
    tooltip_baseline_description: "Fremtidige måneder antager at dine nuværende tilbagevendende indtægter og udgifter fortsætter uændret.",
    tooltip_budget_title: "Budgetprognose",
    tooltip_budget_description: "Fremtidige måneder afspejler dine budgetjusteringer.",
    tooltip_pulse_title: "Månedens projicerede saldo",
    tooltip_pulse_description: "Viser hvordan din kassesaldo udvikler sig over tid. Tidligere måneder afspejler faktiske saldi. Fremtidige måneder er projekterede.",
    empty_state_title: "Ingen pengestrømsdata endnu",
    empty_state_description: "Forbind din bankkonto for at begynde at spore din pengestrøm i realtid og fremtidige projektioner.",
    empty_state_button: "Forbind bankkonto",
    accounts: "Konti",
    bank_accounts: "Bankkonti",
    actual: "Faktisk",
    with_budget: "Med Budget",
    compare_with_budget: "Sammenlign pengestrøm med budget",
    budget_disabled_previous_year: "Budgetprognoser er kun tilgængelige for det indeværende år.",
    group_by: "Gruppér efter",
    group_by_clients: "Kunder",
    group_by_projects: "Projekter",
    group_by_vendors: "Leverandører",
    group_by_none: "Ingen",
    previous_year: "Forrige år",
    next_year: "Næste år",
    unassigned: "Ikke tildelt",
    total_income_ytd: "Samlet Indkomst (År)",
    total_expenses_ytd: "Samlede Udgifter (År)",
    net_cashflow_ytd: "Netto Pengestrøm (År)",
    net_cashflow_month: "Netto Pengestrøm (Måned)",
    end_of_year_projection: "Årsafslutningsprognose",
    jan_to: "Jan - ",
    full_year: "Hele År 2026",
    assuming_budgets_unchanged: "Forudsætter at budgetter forbliver uændrede",
    begin_cashflow: "Månedens startsaldo",
    balance_start_month: "Saldo ved månedens start",
    pulse_cashflow: "Månedens projicerede saldo",
    projected_operational_balance: "Projekteret driftssaldo",
    income: "INDKOMST",
    expenses: "UDGIFTER",
    net_cashflow: "Netto Pengestrøm",
    pulse_cash: "PULSE Cash on Hand",
    end_cashflow: "Slut Pengestrøm",
    month_total: "Månedstotal",
    months: {
    january: "Januar",
    february: "Februar",
    march: "Marts",
    april: "April",
    may: "Maj",
    june: "Juni",
    july: "Juli",
    august: "August",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "December"
    },
    months_short: {
    jan: "Jan",
    feb: "Feb",
    mar: "Mar",
    apr: "Apr",
    may: "Maj",
    jun: "Jun",
    jul: "Jul",
    aug: "Aug",
    sep: "Sep",
    oct: "Okt",
    nov: "Nov",
    dec: "Dec"
    }
  },
  "fi": {
    title: "Kassavirta",
    subtitle: "Seuraa kassavirtaasi ja tulevia ennusteita",
    loading_overview: "Ladataan kassavirtaa...",
    load_error: "Kassavirtaa ei voitu ladata.",
    no_data_label: "Ei tietoja valitulle ajanjaksolle.",
    real_data_label: "Todelliset tiedot",
    monthly_cashflow: "Kuukausittainen kassavirta",
    income_breakdown: "Tulot kategorioittain",
    expense_breakdown: "Menot kategorioittain",
    no_categories: "Ei kategorioita",
    uncategorized: "Luokittelematon",
    uncategorized_badge: "Luokiteltava",
    uncategorized_hint: "Luokittelu parantaa ennusteita ja hälytyksiä",
    budget_difference: "Budjettiero",
    liquidity_risk_title: "Likviditeettiriski",
    liquidity_risk_description: "Ennustettu saldo on negatiivinen tässä kuussa (menot ylittävät tulot).",
    liquidity_drop_title: "Likviditeetin lasku",
    liquidity_drop_description: "Ennustettu saldo laski merkittävästi edelliseen kuukauteen verrattuna.",
    liquidity_delta_label: "Muutos vs edellinen kuukausi",
    liquidity_drop_percent_label: "Lasku",
    all_accounts: "Kaikki tilit",
    all_accounts_short: "Kaikki",
    n_selected: "{{count}} valittu",
    search_accounts: "Hae tilejä...",
    viewing_actual: "Näyttää: Toteutunut",
    viewing_projected: "Näyttää: Ennustettu",
    viewing_baseline_projection: "Perusennuste",
    viewing_baseline_projection_short: "Baseline",
    viewing_budget_projection: "Budjettiennuste",
    viewing_budget_projection_short: "Budjetti",
    based_on_budgets: "Perustuu nykyisiin budjetteihin",
    assumes_recurring_continue: "Olettaa että nykyiset toistuvat tulot ja kulut jatkuvat",
    based_on_budget_assumptions: "Perustuu nykyisiin budjettioletuksiisi",
    tooltip_baseline_title: "Perusennuste",
    tooltip_baseline_description: "Tulevat kuukaudet olettavat että nykyiset toistuvat tulot ja kulut jatkuvat muuttumattomina.",
    tooltip_budget_title: "Budjettiennuste",
    tooltip_budget_description: "Tulevat kuukaudet heijastavat budjettisi muutoksia.",
    tooltip_pulse_title: "Kuukauden ennustettu saldo",
    tooltip_pulse_description: "Näyttää kuinka kassasaldosi kehittyy ajan myötä. Menneet kuukaudet heijastavat todellisia saldoja. Tulevat kuukaudet ovat ennustettuja.",
    empty_state_title: "Ei kassavirtadataa vielä",
    empty_state_description: "Yhdistä pankkitilisi aloittaaksesi kassavirtasi seurannan reaaliajassa ja tulevien ennusteiden kanssa.",
    empty_state_button: "Yhdistä pankkitili",
    accounts: "Tilit",
    bank_accounts: "Pankkitilit",
    actual: "Toteutunut",
    with_budget: "Budjetilla",
    compare_with_budget: "Vertaa kassavirtaa budjettiin",
    budget_disabled_previous_year: "Budjettiennusteet ovat saatavilla vain kuluvalle vuodelle.",
    group_by: "Ryhmittele",
    group_by_clients: "Asiakkaat",
    group_by_projects: "Projektit",
    group_by_vendors: "Toimittajat",
    group_by_none: "Ei mitään",
    previous_year: "Edellinen vuosi",
    next_year: "Seuraava vuosi",
    unassigned: "Ei kohdistettu",
    total_income_ytd: "Kokonaistulot (Vuosi)",
    total_expenses_ytd: "Kokonaiskulut (Vuosi)",
    net_cashflow_ytd: "Nettokassavirta (Vuosi)",
    net_cashflow_month: "Nettokassavirta (Kuukausi)",
    end_of_year_projection: "Vuoden Lopun Ennuste",
    jan_to: "Tam - ",
    full_year: "Koko Vuosi 2026",
    assuming_budgets_unchanged: "Olettaen että budjetit pysyvät muuttumattomina",
    begin_cashflow: "Kuukauden aloitussaldo",
    balance_start_month: "Saldo kuukauden alussa",
    pulse_cashflow: "Kuukauden ennustettu saldo",
    projected_operational_balance: "Ennakoitu toiminnallinen saldo",
    income: "TULOT",
    expenses: "KULUT",
    net_cashflow: "Nettokassavirta",
    pulse_cash: "PULSE Cash on Hand",
    end_cashflow: "Kassavirran Loppu",
    month_total: "Kuukauden Yhteensä",
    months: {
    january: "Tammikuu",
    february: "Helmikuu",
    march: "Maaliskuu",
    april: "Huhtikuu",
    may: "Toukokuu",
    june: "Kesäkuu",
    july: "Heinäkuu",
    august: "Elokuu",
    september: "Syyskuu",
    october: "Lokakuu",
    november: "Marraskuu",
    december: "Joulukuu"
    },
    months_short: {
    jan: "Tam",
    feb: "Hel",
    mar: "Maa",
    apr: "Huh",
    may: "Tou",
    jun: "Kes",
    jul: "Hei",
    aug: "Elo",
    sep: "Syys",
    oct: "Loka",
    nov: "Marras",
    dec: "Joulu"
    }
  },
};
